<template>
  <v-container fluid>
    <v-alert dense outlined type="error" v-if="error">
      <ul>
        <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
      </ul>
    </v-alert>
    <div class="text-h5 mt-5 mb-5 ml-2">{{ $t("UpdateLocation") }}</div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-form ref="form" class="mb-16 pb-10" v-if="list && !loading">
      <v-row>
        <v-col>
          <l-map
            :zoom="15"
            :center="[list.position[1], list.position[0]]"
            style="width: 100%; height: 600px"
          >
            <l-tile-layer :url="url" :attribution="attribution" />
            <l-marker
              draggable
              :lat-lng="[list.position[1], list.position[0]]"
              @update:latLng="updateCoordinates"
            >
            </l-marker>
            <v-autocomplete
              no-filter
              class="map-search"
              hide-details="auto"
              :loading="loading"
              :items="entries"
              :search-input.sync="search"
              item-text="locale_names"
              flat
              dense
              disable-lookup
              outlined
              v-bind:label="$t('1Loc')"
              @change="onChange"
              return-object
              clearable
            ></v-autocomplete>
          </l-map>
        </v-col>
      </v-row>
      <v-footer fixed>
        <v-col class="text-center" cols="12">
          <v-btn
            dark
            min-width="150"
            color="light-blue"
            @click="addMapLocation"
          >
            <span class="mr-2">{{ $t("Save") }}</span>
          </v-btn>
          <v-btn
            color="light-blue"
            text
            class="ml-2"
            min-width="150"
            :to="{
              name: 'PartnerListingViewComponent',
              params: { id: parm }
            }"
          >
            <span>{{ $t("Back") }}</span>
          </v-btn>
        </v-col>
      </v-footer>
    </v-form>
    <WaitDialogComponent :waitDialog="waitDialog" />
  </v-container>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import ListingService from "@/services/ListingService";

export default {
  name: "EditMapComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      loading: true,
      parm: this.$route.params.id,
      waitDialog: false,
      dialog: false,
      error: false,
      coordinates: [],
      list: null,
      items: [],
      search: null,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    };
  },
  watch: {
    search(val) {
      val && val.length > 3 && val !== this.select && this.citySelections(val);
    }
  },
  computed: {
    entries() {
      return this.items.map(e => {
        const locale_names = e.place_name;
        const lat = e.center[1];
        const lng = e.center[0];
        return Object.assign({}, { locale_names, lat, lng });
      });
    }
  },
  created: function() {
    ListingService.viewProperty({
      id: this.parm
    })
      .then(result => {
        this.list = result.data.item;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    onChange(e) {
      if (e) {
        this.list.position = [e.lng, e.lat];
      }
    },
    citySelections(val) {
      if (val) {
        ListingService.citySearch({ query: val })
          .then(result => {
            this.items = result.data.features;
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    },
    updateCoordinates(location) {
      this.coordinates = [location.lng, location.lat];
    },
    async addMapLocation() {
      this.dialog = false;
      this.waitDialog = true;
      await ListingService.updateMapLocation({
        position: this.coordinates,
        property_id: this.parm
      })
        .then(() => {
          setTimeout(() => (this.waitDialog = false), 500);
          this.$router.push({
            name: "PartnerListingViewComponent",
            params: { id: this.parm }
          });
        })
        .catch(err => {
          this.error = err.response.data.errors;
          setTimeout(() => (this.waitDialog = false), 500);
        });
    }
  }
};
</script>

<style></style>
